import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { externalFormFromDto, externalFormLinkFromDto, externalFormLinkFromResponse, externalFormToDto } from '@/features/externalForm/mappers';

const BASE_ENDPOINT = 'account/external-form';

export const getExternalForm = async () => {
  const response = await api.get(buildEndpoint(BASE_ENDPOINT));
  return {
    form: externalFormFromDto(response.data),
    link: externalFormLinkFromDto(response.data),
  };
};

export const updateExternalForm = async (form) => {
  const response = await api.put(buildEndpoint(BASE_ENDPOINT), externalFormToDto(form));
  return externalFormFromDto(response.data);
};

export const uploadExternalFormLogo = async (file) => {
  const body = new FormData();
  body.append('logo', file);
  const response = await api.post(buildEndpoint(BASE_ENDPOINT, { action: 'logo' }), body);
  return externalFormFromDto(response.data);
};

export const deleteExternalFormLogo = async () => {
  const response = await api.delete(buildEndpoint(BASE_ENDPOINT, { action: 'logo' }));
  return externalFormFromDto(response.data);
};

export const generateExternalFormLink = async () => {
  const response = await api.post(buildEndpoint(BASE_ENDPOINT, { action: 'link' }));
  return externalFormLinkFromResponse(response.data);
};

export const getExternalFormShareLink = async () => {
  const response = await api.get(buildEndpoint(BASE_ENDPOINT, { action: 'link' }));
  const url = response.data?.url;
  return typeof url === 'string' && url.trim() ? url.trim() : null;
};
